import {ActivityAreaResource, CompanySuggestionsResource, ExperienceResource} from '@/common/api/api-raw-types';
import {urlService} from 'vue3-starter/dist/http/UrlService';
import {context} from 'vue3-starter/src/typescript/app-context/AppContext';
import {ActivityArea, CompanySuggestion, Experience} from '../../domain/experience/Experience';
import {ExperienceRepository} from '../../domain/experience/ExperienceRepository';
import {toUpdateExperiencesRequest} from '../mapper/request/UpdateExperiencesRequestMapper';
import {toActivityArea} from '../mapper/resource/ActivityAreaResourceMapper';
import {toCompanySuggestion} from '../mapper/resource/CompanySuggestionResourceMapper';
import {toExperience} from '../mapper/resource/ExperienceResourceMapper';

export class ExperienceRepositoryAPI implements ExperienceRepository {
    async fetchActivityAreas(): Promise<ActivityArea[]> {
        const [data, error] = await context.httpService.get<ActivityAreaResource[]>(context.registry.entries.allActivityAreas());
        if (error) {
            throw new Error(error.message);
        }

        return data!.map((area) => toActivityArea(area));
    }

    async fetchExperiences(): Promise<Experience[]> {
        const [data, error] = await context.httpService.get<ExperienceResource[]>(context.registry.entries.getExperiences());
        if (error) {
            throw new Error(error.message);
        }

        const experiences: Experience[] = [];
        if (data && data.length > 0) {
            data.forEach((experienceResource) => {
                experiences.push(toExperience(experienceResource));
            });
        }

        return experiences;
    }

    async searchCompanies(query: string): Promise<CompanySuggestion[]> {
        const entry = `${urlService.buildUrl(context.registry.entries.suggestCompanies(), query)}`;

        const [data, error] = await context.httpService.get<CompanySuggestionsResource>(entry);
        if (error) {
            throw new Error(error.message);
        }

        const companySuggestions: CompanySuggestion[] = [];
        if (data && data.suggestions && data.suggestions.length > 0) {
            data.suggestions.forEach((companySuggestionResource) => {
                companySuggestions.push(toCompanySuggestion(companySuggestionResource));
            });
        }

        return companySuggestions;
    }

    async updateExperiences(experiences: Experience[]): Promise<void> {
        const experienceRequest = toUpdateExperiencesRequest(experiences);

        const [data, error] = await context.httpService.post(context.registry.entries.updateExperiences(), experienceRequest);
        if (error) {
            throw new Error(error.message);
        }
    }
}
